import { useRef } from "react";
import { createContext, useContext, useState, useEffect } from "react";
import { useUserStore } from "./useUserStore";
import SpecificAPI from "../services/SpecificApi";

const ModulesContext = createContext(null);

export const ModulesProvider = ({ children }) => {
  const hasLoadedRef = useRef(false);
  const { authToken, isAppUserLoading, appUser } = useUserStore();

  const [modules, setModules] = useState([]);
  const [teachingModules, setTeachingModules] = useState([]);
  const [administrativeModules, setAdministrativeModules] = useState([]);
  const [managementModules, setManagementModules] = useState([]);
  const [isModulesLoading, setIsModulesLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadModules = async () => {
      if (!appUser || isAppUserLoading) return;
      if (hasLoadedRef.current) return;

      try {
        setIsModulesLoading(true);

        let ModuleData = [];

        if (appUser?.role !== "student") {
          const response = await SpecificAPI.getModules({});
          ModuleData = response?.data || [];
        }

        const teachingModulesData = ModuleData.filter((m) => m.type === "teaching");
        const administrativeModulesData = ModuleData.filter((m) => m.type === "administration");
        const managementModulesData = ModuleData.filter((m) => m.type === "management");

        setModules(ModuleData);
        setTeachingModules(teachingModulesData);
        setAdministrativeModules(administrativeModulesData);
        setManagementModules(managementModulesData);

        hasLoadedRef.current = true; // ✅ set AFTER successful load
        setIsModulesLoading(false);
      } catch (err) {
        console.error("Failed to load Modules:", err);
        setError(err);
        setIsModulesLoading(false);
      }
    };

    loadModules();
  }, [appUser, authToken, isAppUserLoading]);

  return (
    <ModulesContext.Provider
      value={{
        modules,
        teachingModules,
        administrativeModules,
        managementModules,
        isModulesLoading,
        error,
        setModules,
      }}
    >
      {children}
    </ModulesContext.Provider>
  );
};

export const useModulesStore = () => useContext(ModulesContext);
